import { Helmet } from "react-helmet";
import NavbarProgram from "../../components/NavbarProgram";
import { googleFormEnglish } from "../../constant";
import PaymentSection from "../../components/paymentSection";
import { programData, ProgramType } from "../../data/programData";
import ServiceProcess from "../../components/serviceProcess";

const features = [
  {
    title: "Logical Flow Enhancement",
    description:
      "Strengthen your narrative structure and build persuasive reasoning throughout your cover letter.",
  },
  {
    title: "Paragraph-based Structural Analysis",
    description: "Identify strengths, weaknesses, and actionable improvements within each section.",
  },
  {
    title: "Direct Editing & UK-style Optimisation",
    description: "Refine tone, vocabulary, and clarity to meet UK professional standards.",
  },
  {
    title: "Core UK Cover Letter Principles",
    description: "Learn the position-specific structure that UK recruiters expect.",
  },
  {
    title: "Future Improvement Guide",
    description: "Receive strategic advice for long-term development beyond this review.",
  },
];

const CoverLetter: React.FC = () => {
  const program = programData.find((p) => p.id === ProgramType.CoverLetter)!;

  return (
    <div className="flex flex-col min-h-screen">
      <Helmet>
        <title>BeMe – UK Cover Letter Consulting Program</title>
        <meta
          name="description"
          content="BeMe UK Cover Letter consulting: expert 1:1 feedback for international students entering the UK job market."
        />
      </Helmet>

      <NavbarProgram />

      <section className="bg-main text-white py-20 px-4 text-center">
        <h1 className="ext-4xl md:text-5xl font-bold mb-6 leading-tight">Cover Letter Consulting</h1>
        <p className="max-w-2xl mx-auto text-lg md:text-xl text-sub/90 mb-8">
          Logic-driven consulting that builds your perfect motivation story for the UK job market.
        </p>

        <a
          href={googleFormEnglish}
          className="inline-block bg-accent text-white px-8 py-3 rounded-lg font-semibold shadow-md hover:bg-yellow-600 transition-colors"
        >
          Get Started
        </a>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-sub">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-main text-center mb-12">What You Get</h2>
          <div className="grid md:grid-cols-2 gap-10">
            {features.map((feature, idx) => (
              <div
                key={idx}
                className="bg-white p-6 rounded shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-main mb-2">{feature.title}</h3>
                <p className="text-gray-700">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <section className="bg-white py-20 px-4 text-center">
        <ServiceProcess label={program.label} />
      </section>

      <section className="bg-sub py-20 px-4 text-center">
        <PaymentSection program={program} />
      </section>
    </div>
  );
};

export default CoverLetter;
